import {VariantConfigT} from '@/lib/types/colors.types';

export const successConfig: VariantConfigT = {
  basic: {
    icon: 'success',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'success',
    active: 'success',
  },
  outline: {
    icon: 'success',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'success',
    iconHover: 'success',
    iconActive: 'success',
    hover: 'success',
    active: 'success',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
